/* Echarts图表字体、间距自适应 */
export const fitChartSize = (size, defalteWidth = 1920) => {
  let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (!clientWidth) return size;
  let scale = (clientWidth / defalteWidth);
  return Number((size * scale).toFixed(3));
};

/**
 * 车牌英文转换工具
 *
 * 京：北京
 * 津：天津
 * 冀：河北
 * 晋：山西
 * 蒙：内蒙古
 * 辽：辽宁
 * 吉：吉林
 * 黑：黑龙江
 * 沪：上海
 * 苏：江苏
 * 浙：浙江
 * 皖：安徽
 * 闽：福建
 * 赣：江西
 * 鲁：山东
 * 豫：河南
 * 鄂：湖北
 * 湘：湖南
 * 粤：广东
 * 桂：广西
 * 琼：海南
 * 渝：重庆
 * 川：四川
 * 贵：贵州
 * 云：云南
 * 藏：西藏
 * 陕：陕西
 * 甘：甘肃
 * 青：青海
 * 宁：宁夏
 * 新：新疆
 * 使: 外交车辆,
 * 领: 领事车辆,
 * 警: 警用车辆,
 * 港: 香港车辆,
 * 澳: 澳门车辆,
 *
 * @param carNo
 */
export function transCarNoToEn(carNo) {
  const carMap = {
    '京': 'AA',
    '津': 'BB',
    '冀': 'CC',
    '晋': 'DD',
    '蒙': 'EE',
    '辽': 'FF',
    '吉': 'GG',
    '黑': 'HH',
    '沪': 'II',
    '苏': 'JJ',
    '浙': 'KK',
    '皖': 'LL',
    '闽': 'MM',
    '赣': 'NN',
    '鲁': 'OO',
    '豫': 'PP',
    '鄂': 'QQ',
    '湘': 'RR',
    '粤': 'SS',
    '桂': 'TT',
    '琼': 'UU',
    '渝': 'VV',
    '川': 'WW',
    '贵': 'XX',
    '云': 'YY',
    '藏': 'ZZ',
    '陕': 'A1',
    '甘': 'B2',
    '青': 'C3',
    '宁': 'D4',
    '新': 'E5',
    '使': 'F6',
    '领': 'G7',
    '警': 'H8',
    '港': 'I9',
    '澳': 'J0',
  };
  const newCarNo = carMap[carNo.substring(0, 1)] + carNo.substring(1, carNo.length);
  console.log(`原始车牌号:${carNo},转换后的车牌号:${newCarNo}`);
  return newCarNo;
}

/**
 * 转换后的车牌号还原为原始中文车牌号
 *
 * @param carEn
 * @returns {string}
 */
export function transEnToCarNo(carEn) {
  const carMap = {
    'AA': '京',
    'BB': '津',
    'CC': '冀',
    'DD': '晋',
    'EE': '蒙',
    'FF': '辽',
    'GG': '吉',
    'HH': '黑',
    'II': '沪',
    'JJ': '苏',
    'KK': '浙',
    'LL': '皖',
    'MM': '闽',
    'NN': '赣',
    'OO': '鲁',
    'PP': '豫',
    'QQ': '鄂',
    'RR': '湘',
    'SS': '粤',
    'TT': '桂',
    'UU': '琼',
    'VV': '渝',
    'WW': '川',
    'XX': '贵',
    'YY': '云',
    'ZZ': '藏',
    'A1': '陕',
    'B2': '甘',
    'C3': '青',
    'D4': '宁',
    'E5': '新',
    'F6': '使',
    'G7': '领',
    'H8': '警',
    'I9': '港',
    'J0': '澳',
  };

  const newCarNo = carMap[carEn.substring(0, 2)] + carEn.substring(2, carEn.length);
  console.log(`转换前车牌号:${carEn},转换后的原始中文车牌号:${newCarNo}`);
  return newCarNo;
}

/**
 * 判断是否为车牌号
 * 特殊车牌长度判断待验证
 *
 * 判断一个字符串是否为车牌号可以通过正则表达式来实现。车牌号的格式规定是由一个汉字和一个字母组成的省份简称，
 * 后面是一串数字和字母的组合，其中字母不包括I和O，长度一般为5-8位。
 *
 * @param str
 * @returns {boolean}
 */
export function isCarNo(str) {
  // 省份简称
  const provinces = ['京', '津', '沪', '渝', '冀', '豫', '云', '辽', '黑', '湘', '皖', '鲁', '新', '苏', '浙', '赣', '鄂', '桂',
    '甘', '晋', '蒙', '陕', '吉', '闽', '贵', '粤', '青', '藏', '川', '宁', '琼', '使', '领', '警', '港', '澳'];

  // 正则表达式
  const regex = new RegExp(`^[${provinces.join('')}]([A-HJ-NP-Z]|[0-9]){5,7}$`);
  return regex.test(str);
}

/**
 * 简单的防抖函数
 *
 * @param fn
 * @param wait
 * @returns {(function(): void)|*}
 */
export const debounce = (fn, wait = 500) => function () {
  clearTimeout(fn.timer);
  // eslint-disable-next-line no-param-reassign,prefer-rest-params
  fn.timer = setTimeout(fn.bind(this, ...arguments), wait);
};

/**
 * 根据cityId动态显示城市名称
 *
 * SELECT
 *  dict_value,
 *  dict_val_text ,
 *  CONCAT_WS('','"', dict_value, '":"', dict_val_text,'"')
 * FROM
 *  `apsara`.`base_dict`
 * WHERE
 *  `dict_name` LIKE '%城市%'
 *
 * @param cityId
 */
export function getCityName(cityId) {
  const cityMap = {
    '1': '北京',
    '2': '天津',
    '3': '石家庄',
    '4': '唐山',
    '5': '秦皇岛',
    '6': '邯郸',
    '7': '邢台',
    '8': '保定',
    '9': '张家口',
    '10': '承德',
    '11': '沧州',
    '12': '廊坊',
    '13': '衡水',
    '14': '太原',
    '15': '大同',
    '16': '阳泉',
    '17': '长治',
    '18': '晋城',
    '19': '朔州',
    '20': '晋中',
    '21': '运城',
    '22': '忻州',
    '23': '临汾',
    '24': '吕梁',
    '25': '呼和浩特',
    '26': '包头',
    '27': '乌海',
    '28': '赤峰',
    '29': '通辽',
    '30': '鄂尔多斯',
    '31': '呼伦贝尔',
    '32': '巴彦淖尔',
    '33': '乌兰察布',
    '34': '兴安盟',
    '35': '锡林郭勒盟',
    '36': '阿拉善盟',
    '37': '沈阳',
    '38': '大连',
    '39': '鞍山',
    '40': '抚顺',
    '41': '本溪',
    '42': '丹东',
    '43': '锦州',
    '44': '营口',
    '45': '阜新',
    '46': '辽阳',
    '47': '盘锦',
    '48': '铁岭',
    '49': '朝阳',
    '50': '葫芦岛',
    '51': '长春',
    '52': '吉林',
    '53': '四平',
    '54': '辽源',
    '55': '通化',
    '56': '白山',
    '57': '松原',
    '58': '白城',
    '59': '延边',
    '60': '哈尔滨',
    '61': '齐齐哈尔',
    '62': '鸡西',
    '63': '鹤岗',
    '64': '双鸭山',
    '65': '大庆',
    '66': '伊春',
    '67': '佳木斯',
    '68': '七台河',
    '69': '牡丹江',
    '70': '黑河',
    '71': '绥化',
    '72': '大兴安岭',
    '73': '上海',
    '74': '南京',
    '75': '无锡',
    '76': '徐州',
    '77': '常州',
    '78': '苏州',
    '79': '南通',
    '80': '连云港',
    '81': '淮安',
    '82': '盐城',
    '83': '扬州',
    '84': '镇江',
    '85': '泰州',
    '86': '宿迁',
    '87': '杭州',
    '88': '宁波',
    '89': '温州',
    '90': '嘉兴',
    '91': '湖州',
    '92': '绍兴',
    '93': '金华',
    '94': '衢州',
    '95': '舟山',
    '96': '台州',
    '97': '丽水',
    '98': '合肥',
    '99': '芜湖',
    '100': '蚌埠',
    '101': '淮南',
    '102': '马鞍山',
    '103': '淮北',
    '104': '铜陵',
    '105': '安庆',
    '106': '黄山',
    '107': '滁州',
    '108': '阜阳',
    '109': '宿州',
    '111': '六安',
    '112': '亳州',
    '113': '池州',
    '114': '宣城',
    '115': '福州',
    '116': '厦门',
    '117': '莆田',
    '118': '三明',
    '119': '泉州',
    '120': '漳州',
    '121': '南平',
    '122': '龙岩',
    '123': '宁德',
    '124': '南昌',
    '125': '景德镇',
    '126': '萍乡',
    '127': '九江',
    '128': '新余',
    '129': '鹰潭',
    '130': '赣州',
    '131': '吉安',
    '132': '宜春',
    '133': '抚州',
    '134': '上饶',
    '135': '济南',
    '136': '青岛',
    '137': '淄博',
    '138': '枣庄',
    '139': '东营',
    '140': '烟台',
    '141': '潍坊',
    '142': '济宁',
    '143': '泰安',
    '144': '威海',
    '145': '日照',
    '146': '莱芜',
    '147': '临沂',
    '148': '德州',
    '149': '聊城',
    '150': '滨州',
    '151': '菏泽',
    '152': '郑州',
    '153': '开封',
    '154': '洛阳',
    '155': '平顶山',
    '156': '安阳',
    '157': '鹤壁',
    '158': '新乡',
    '159': '焦作',
    '160': '濮阳',
    '161': '许昌',
    '162': '漯河',
    '163': '三门峡',
    '164': '南阳',
    '165': '商丘',
    '166': '信阳',
    '167': '周口',
    '168': '驻马店',
    '169': '武汉',
    '170': '黄石',
    '171': '十堰',
    '172': '宜昌',
    '173': '襄阳',
    '174': '鄂州',
    '175': '荆门',
    '176': '孝感',
    '177': '荆州',
    '178': '黄冈',
    '179': '咸宁',
    '180': '随州',
    '181': '恩施',
    '182': '神农架',
    '183': '长沙',
    '184': '株洲',
    '185': '湘潭',
    '186': '衡阳',
    '187': '邵阳',
    '188': '岳阳',
    '189': '常德',
    '190': '张家界',
    '191': '益阳',
    '192': '郴州',
    '193': '永州',
    '194': '怀化',
    '195': '娄底',
    '196': '湘西',
    '197': '广州',
    '198': '韶关',
    '199': '深圳',
    '200': '珠海',
    '201': '汕头',
    '202': '佛山',
    '203': '江门',
    '204': '湛江',
    '205': '茂名',
    '206': '肇庆',
    '207': '惠州',
    '208': '梅州',
    '209': '汕尾',
    '210': '河源',
    '211': '阳江',
    '212': '清远',
    '213': '东莞',
    '214': '中山',
    '215': '潮州',
    '216': '揭阳',
    '217': '云浮',
    '218': '南宁',
    '219': '柳州',
    '220': '桂林',
    '221': '梧州',
    '222': '北海',
    '223': '防城港',
    '224': '钦州',
    '225': '贵港',
    '226': '玉林',
    '227': '百色',
    '228': '贺州',
    '229': '河池',
    '230': '来宾',
    '231': '崇左',
    '232': '海口',
    '233': '三亚',
    '234': '重庆',
    '235': '成都',
    '236': '自贡',
    '237': '攀枝花',
    '238': '泸州',
    '239': '德阳',
    '240': '绵阳',
    '241': '广元',
    '242': '遂宁',
    '243': '内江',
    '244': '乐山',
    '245': '南充',
    '246': '眉山',
    '247': '宜宾',
    '248': '广安',
    '249': '达州',
    '250': '雅安',
    '251': '巴中',
    '252': '资阳',
    '253': '阿坝',
    '254': '甘孜',
    '255': '凉山',
    '256': '贵阳',
    '257': '六盘水',
    '258': '遵义',
    '259': '安顺',
    '260': '铜仁',
    '261': '黔西南',
    '262': '毕节',
    '263': '黔东南',
    '264': '黔南',
    '265': '昆明',
    '266': '曲靖',
    '267': '玉溪',
    '268': '保山',
    '269': '昭通',
    '270': '丽江',
    '272': '临沧',
    '273': '楚雄',
    '274': '红河',
    '275': '文山',
    '276': '西双版纳',
    '277': '大理',
    '278': '德宏',
    '279': '怒江',
    '280': '迪庆',
    '281': '拉萨',
    '282': '昌都',
    '283': '山南',
    '284': '日喀则',
    '285': '那曲',
    '286': '阿里',
    '287': '林芝',
    '288': '西安',
    '289': '铜川',
    '290': '宝鸡',
    '291': '咸阳',
    '292': '渭南',
    '293': '延安',
    '294': '汉中',
    '295': '榆林',
    '296': '安康',
    '297': '商洛',
    '298': '兰州',
    '299': '嘉峪关',
    '300': '金昌',
    '301': '白银',
    '302': '天水',
    '303': '武威',
    '304': '张掖',
    '305': '平凉',
    '306': '酒泉',
    '307': '庆阳',
    '308': '定西',
    '309': '陇南',
    '310': '临夏',
    '311': '甘南',
    '312': '西宁',
    '313': '海东',
    '314': '海北',
    '315': '黄南',
    '316': '海南',
    '317': '果洛',
    '318': '玉树',
    '319': '海西',
    '320': '银川',
    '321': '石嘴山',
    '322': '吴忠',
    '323': '固原',
    '324': '中卫',
    '325': '乌鲁木齐',
    '326': '克拉玛依',
    '327': '吐鲁番',
    '328': '哈密',
    '329': '昌吉',
    '330': '博尔塔拉',
    '331': '巴音郭楞',
    '332': '阿克苏',
    '333': '克州',
    '334': '喀什',
    '335': '和田',
    '336': '伊犁',
    '337': '塔城',
    '338': '阿勒泰',
    '329001': '石河子',
    '329002': '阿拉尔',
    '329003': '图木舒克',
    '329004': '五家渠',
    '329005': '铁门关',
    '16316': '济源',
    '17514': '仙桃',
    '17515': '潜江',
    '17516': '天门',
    '12313': '钓鱼岛',
    '28025': '普洱',
    '23321': '东方',
    '23322': '临高',
    '23323': '澄迈',
    '23324': '儋州',
    '23325': '昌江',
    '23326': '白沙',
    '23327': '琼中',
    '23328': '定安',
    '23329': '屯昌',
    '23330': '琼海',
    '23331': '文昌',
    '23332': '保亭',
    '23333': '万宁',
    '23334': '陵水',
    '23335': '西沙',
    '23336': '南沙',
    '23337': '乐东',
    '23338': '五指山',
    '23339': '中沙',
    '3265501': '香港',
    '3265601': '澳门',
    '3265701': '台北',
    '3265702': '高雄',
    '3265703': '台中',
  };
  return cityMap[cityId];
}
